import { KwantisWellDTO } from './well';

export type WellPlansListFiltersState = Record<WELL_PLANS_LIST_FILTERS, string[]>;

export class WellPlansListFiltersStateClass {
  country: string[] = [];
  affiliate: string[] = [];
  name: string[] = [];
  tuwi: string[] = [];
}

export enum WELL_PLANS_LIST_FILTERS {
  NAME = 'name',
  TUWI = 'tuwi',
  COUNTRY = 'country',
  AFFILIATE = 'affiliate',
}

export enum FILTERS {
  COUNTRIES = 'countries',
  AFFILIATE = 'affiliate',
  PRODUCT_LINE = 'product_line',
  FIELD = 'block_area',
  RIG_TYPE = 'rig_type',
  RIG_NAME = 'rig_name',
  WELL_PROFILE = 'well_profile',
  WATER_DEPTH = 'water_depth',
  SPUD_DATE = 'spud_date',
  WELLS = 'wells',
}

export const autocompleteFilters = [
  FILTERS.COUNTRIES,
  FILTERS.AFFILIATE,
  FILTERS.PRODUCT_LINE,
  FILTERS.FIELD,
  FILTERS.RIG_TYPE,
  FILTERS.RIG_NAME,
  FILTERS.WELL_PROFILE,
  FILTERS.WELLS,
] as const;

export type AUTOCOMPLETE_FILTERS = (typeof autocompleteFilters)[number];

export type ArrayFiltersState = {
  countries: string[];
  affiliate: string[];
  product_line: string[];
  block_area: string[];
  rig_type: string[];
  rig_name: string[];
  well_profile: string[];
  wells: string[];
};

export type FiltersState = ArrayFiltersState & {
  water_depth: {
    from: number | null;
    to: number | null;
  };
  spud_date: {
    from: Date | null;
    to: Date | null;
  };
};

export class FiltersStateClass {
  countries: string[] = [];
  affiliate: string[] = [];
  product_line: string[] = [];
  block_area: string[] = [];
  rig_type: string[] = [];
  rig_name: string[] = [];
  well_profile: string[] = [];
  water_depth: {
    from: number | null;
    to: number | null;
  } = { from: null, to: null };
  spud_date: {
    from: Date | null;
    to: Date | null;
  } = { from: null, to: null };
  wells: string[] = [];
}

export type FiltersApiResponse = {
  countries: string[];
  affiliate: string[];
  product_line: string[];
  block_area: string[];
  rig_name: string[];
  wells: KwantisWellDTO[];
  rig_type: string[];
  well_profile: string[];
};

export type FiltersPayload = {
  countries?: string[];
  affiliate?: string[];
  product_line?: string[];
  block_area?: string[];
  rig_type?: string[];
  rig_name?: string[];
  well_profile?: string[];
  water_depth?: [number | null, number | null];
  spud_date?: [string | null, string | null];
  wells?: string[];
};
